<template lang="pug">
.navigation
  v-app-bar.white.elavation-0(app light :style="$vuetify.breakpoint.smAndDown ? 'box-shadow: 0 2px 4px 0 rgba(0,0,0,.0) !important;' : 'box-shadow: 0 2px 4px 0 rgba(0,0,0,.08) !important;'")
    div
      v-btn(icon small  @click.stop='drawer = !drawer')
        eva-icon(name="menu-outline" :fill="$vuetify.theme.themes[$theme].primary500")
    div.ml-6
      .h6.primary500--text {{ $t('yezza_affiliate') }}
    v-spacer
    v-app-bar-nav-icon.my-auto.mx-2(@click.stop='openZenDesk()' small)
      eva-icon(name="question-mark-circle-outline" :fill="$vuetify.theme.themes[$theme].primary500")
    v-badge(overlap small :value="notificationCount" :content="notificationCount" dot color="textColorAccent")
      v-btn(icon small to="/affiliate/notifications" @click="notificationCount = 0")
         eva-icon(name="bell-outline" :fill="$vuetify.theme.themes[$theme].primary500")

  v-navigation-drawer.white(app v-model='drawer' fixed :width="$vuetify.breakpoint.mdAndUp ? '270' : '250'")
    v-layout.px-4(v-if="affiliate.user" @click.stop='childMenu = !childMenu' style="height:112px")
      intel-avatar.mr-3.ml-1.my-auto(v-if="drawer" :code="affiliate.user.avatar_code" :id="affiliate.user.id" size=40)
      v-list-item-content.ml-2.my-auto
        .h6.primary500--text(v-text='affiliate.user.first_name')
      v-list-item-icon.my-auto
        eva-icon(:name="childMenu? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline' " width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary500")
    v-expand-transition.white
      v-list.pa-0(v-show="childMenu" dense :color="$vuetify.theme.themes[$theme].infoT08")
        v-list-item(@click="switchCompany" style="height:54px")
          .s1 {{ $t('switch_company') }}
        v-list-item(@click="$router.push('/signout')" style="height:54px")
          .s1.danger--text {{ $t('sign_out') }}
    v-divider.basic400(style="border:1px solid; ")

    v-list.pa-0(flat dense )
      v-list-item-group.pa-0
        router-link(to="/affiliate/dashboard" v-slot="{ href, route, navigate, isActive, isExactActive }")
          v-layout(style="height:54px;" @click="navigate")
            div(vertical style="width:4px;" :style="isActive? `background-color: ${$vuetify.theme.themes[$theme].info}` : ''")
            v-list-item(:style="isActive? `background-color: ${$vuetify.theme.themes[$theme].infoT08}` : ''")
              v-list-item-icon.my-auto
                eva-icon(name="home-outline" :fill="isActive ? $vuetify.theme.themes[$theme].info : $vuetify.theme.themes[$theme].primary400")
              v-list-item-content.ml-n3.my-auto
                .s1(:class="isActive? 'info--text' : 'primary400--text'") {{ $t('home') }}

        .profile
          v-divider.basic300
          router-link(to="/affiliate/profile" v-slot="{ href, route, navigate, isActive, isExactActive }")
            v-layout(style="height:54px;" @click="navigate")
              div(vertical style="width:4px;" :style="isActive? `background-color: ${$vuetify.theme.themes[$theme].info}` : ''")
              v-list-item(:style="isActive? `background-color: ${$vuetify.theme.themes[$theme].infoT08}` : ''")
                v-list-item-icon.my-auto
                  eva-icon(name="person-outline" :fill="isActive ? $vuetify.theme.themes[$theme].info : $vuetify.theme.themes[$theme].primary400")
                v-list-item-content.ml-n3.my-auto
                  .s1(:class="isActive? 'info--text' : 'primary400--text'") {{ $t('profile') }}
    .modals
      y-dialog(fill-height fluid v-model="showSupportDialog" transition="fade-transition" scrollable persistent max-width="400px")
        v-card
          v-card-title(style="height:56px;")
            .h6.basic800--text {{ $t('leave_us_a_message') }}
          v-divider.basic300
          v-card-text.py-3
            .s1 {{ $t('how_can_we_help') }}
            .p2.primary400--text {{ $t('if_you_have_questions') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='showSupportDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' dark depressed heigh=32 @click="sendEmail")
              .button-AA-small.basic100--text {{ $t('send_message') }}

</template>

<script>
import IntelAvatar from '@/components/IntelAvatar.vue'
export default {
  components: { IntelAvatar },
  props: ['propAffiliate', 'propNotificationCount'],
  data: () => ({
    drawer: false,
    childMenu: false,
    cwInterval: null,
    zdWidget: null,
    showSupportDialog: false,
  }),
  computed: {
    affiliate: {
      get() {
        return this.propAffiliate
      },
      set(newValue) {
        this.$emit('update:propAffiliate', newValue)
      }
    },
    notificationCount: {
      get() {
        return this.propNotificationCount
      },
      set(newValue) {
        this.$emit('update:propNotificationCount', newValue)
      }
    },
  },
  mounted () {
    this.drawer = window.innerWidth > 600
    window.zE(() => {
      window.zE.show()
    })
    this.cwInterval = setInterval(() => {
      const iframe = document.getElementById('launcher')
      if (iframe) {
        this.zdWidget = iframe.contentWindow.document.getElementById('Embed')
        if (this.zdWidget) {
          this.zdWidget.style.display = 'none'
          clearInterval(this.cwInterval)
        }
      }
    }, 200)
  },
  watch: {
    drawer (val) {
      this.$store.commit('ui/setDialogVisibility', val)
    }
  },
  methods: {
    openZenDesk() {
      // this.showSupportDialog = true
      // CELCOM
      if (this.zdWidget) {
        const paths = this.$route.path.split('/')
        paths.shift()
        paths.shift()
        const searchKeywords = paths.join(" ")
        window.zE('webWidget', 'helpCenter:setSuggestions', { search: searchKeywords  })
        this.zdWidget.querySelectorAll("button")[0].click()
      }
    },
    sendEmail() {
      window.open(`mailto:support@yezza.io?subject=Question &body= %0D%0A %0D%0A %0D%0A Company: ${window.location.href} %0D%0A %0D%0A Regards, %0D%0A ${this.affiliate.user.first_name + ' ' + this.affiliate.user.last_name}`, '_blank')
      this.showSupportDialog = false
    },
    switchCompany () {
      if (this.$subdomain) {
        document.location.href = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/companies`
      } else {
        this.$router.push('/admin')
      }
    },
    switchDesign () {
      document.location.href = `https://app.yezza.my/signin`
    }
  }
}
</script>

<style scoped>
.company-name {
  height: 1.5em;
  overflow: hidden;
}
</style>

<i18n>
{
  "en": {
    "yezza_affiliate": "Yezza Affiliate",
    "switch_company": "Switch company",
    "home": "Home",
    "profile": "Profile",
    "leave_us_a_message": "Leave us a message",
    "how_can_we_help": "How can we help you?",
    "if_you_have_questions": "If you have any questions, please contact us at support@yezza.io. We'd be happy to help.",
    "send_message": "Send Message"
  },
  "id": {
    "yezza_affiliate": "Afiliasi Yezza",
    "switch_company": "Pindah perusahaan",
    "home": "Home",
    "profile": "Profil",
    "leave_us_a_message": "Tinggalkan kami pesan",
    "how_can_we_help": "Bagaimana kami dapat membantu kamu?",
    "if_you_have_questions": "Jika kamu memiliki pertanyaan, silakan hubungi kami di support@yezza.io. Kami akan dengan senang hati membantu.",
    "send_message": "Kirim pesan"
  }
}
</i18n>
